<template>
	<div v-if="order" class="white" style="color: black">
		<v-container fluid style="max-width: 1200px">
			<div class="d-flex ba block w-100 mb-1">
				<div style="width: 200px; height: 110px" class="br">
					<img height="100" class="mt-2 mx-auto" contain src="@/assets/lusazu_logo.png" />
				</div>
				<div style="flex: 3" class="align-self-center">
					<div class="text-h4 font-weight-bold">
						PLANILLA CONTROL DE ROEDORES
					</div>
				</div>
				<div style="flex: 1" class="bl">
					<div class="font-weight-medium title">Resolucion Sanitaria</div>
					<div class="font-weight-medium body-1 font-weight-bold">
						Nº 7776-10-2019
					</div>
					<div class="font-weight-medium body-1 font-weight-bold">ISO 9001</div>
				</div>
			</div>
			<div class="text-left bb d-flex justify-space-between align-center">
				<div>
					<div class="body-2">
						REPRESENTANTE LEGAL: Luis Hernán Salazar Zuazo / RUT: 10.511.968-2
					</div>
					<div class="body-2">Calle Santa Lucia Nº 103 - Graneros</div>
					<div class="body-2">TELÉFONOS: +56 9 9638 3844</div>
				</div>
				<div class="title font-weight-bold">№ DR {{ order.id }}</div>
			</div>
			<div class="d-flex mt-2">
				<div style="flex: 1" class="bb d-flex align-center text-left">
					<div style="width: 70px" class="text-uppercase body-1 mr-2">
						Fecha:
					</div>
					<div style="width: 100%">{{ order.data[0] }}</div>
				</div>
				<div style="flex: 1" class="bb d-flex align-center text-left">
					<div style="width: 200px" class="text-uppercase body-1 mr-2">
						HORA INICIO:
					</div>
					<div style="width: 100%">{{ order.startHour }}</div>
				</div>
				<div style="flex: 1" class="bb d-flex flex-no-wrap align-center text-left">
					<div style="width: 250px" class="text-uppercase body-1 mr-2">
						HORA TERMINO:
					</div>
					<div style="width: 100%">{{ order.endHour }}</div>
				</div>
			</div>
			<div class="d-flex align-center text-left mt-2">
				<div style="flex: 1" class="d-flex align-center">
					<label for="programados">
						SERVICIOS PROGRAMADOS
					</label>
					<input
						id="programados"
						class="ml-2"
						v-model="order.data[3]"
						style="width: 15px"
						type="checkbox"
					/>
				</div>
				<div style="flex: 1" class="d-flex align-center">
					<label for="extras">
						SERVICIOS EXTRAS
					</label>
					<input
						id="extras"
						class="ml-2"
						v-model="order.data[4]"
						style="width: 15px"
						type="checkbox"
					/>
				</div>
			</div>
			<div class="d-flex mt-2">
				<div style="flex: 1" class="bb d-flex flex-no-wrap align-center text-left">
					<div style="width: 70px" class="text-uppercase body-1 mr-2">
						CLIENTE:
					</div>
					<div style="width: 100%">{{ order.data[6] }}</div>
				</div>
				<div style="flex: 1" class="bb d-flex flex-no-wrap align-center text-left">
					<div style="width: 70px" class="text-uppercase body-1 mr-2">
						PLANTA:
					</div>
					<div style="width: 100%">{{ order.data[7] }}</div>
				</div>
			</div>
			<div style="flex: 2" class="bb d-flex flex-no-wrap align-center text-left">
				<span class="text-uppercase body-1 mr-2">
					Dirección:
				</span>
				<span>{{ order.data[8] }}</span>
			</div>
			<div class="d-flex">
				<div style="flex: 2" class="bb d-flex flex-no-wrap align-center text-left">
					<span class="text-uppercase body-1 mr-2">
						Nombre solicitante:
					</span>
					<span>{{ order.data[9] }}</span>
				</div>
				<div style="flex: 2" class="bb d-flex flex-no-wrap align-center text-left">
					<span class="text-uppercase body-1 mr-2">
						RUT solicitante:
					</span>
					<span>{{ order.data[10] }}</span>
				</div>
			</div>
			<div style="flex: 2" class="bb d-flex flex-no-wrap align-center text-left">
				<span class="text-uppercase body-1 mr-2">
					Responsable planta:
				</span>
				<span>{{ order.data[11] }}</span>
			</div>
			<div style="flex: 2" class="bb d-flex flex-no-wrap align-center text-left">
				<span class="text-uppercase body-1 mr-2">
					Tecnico responsable del trabajo:
				</span>
				<span>{{ order.data[12] }}</span>
			</div>
			<div class="d-flex align-start mt-1">
				<div class="d-flex align-center">
					<span class="mr-2 font-italic body-1 text-uppercase">
						DESRATIZACIÓN
					</span>
				</div>
			</div>
			<div class="d-flex">
				<div style="flex: 1">
					<div class="text-left mb-2">
						<span style="font-size:16px; font-weight:bold;">
							Descripción de trampas
						</span>
					</div>
					<div class="mb-1 d-flex justify-space-between">
						<span>Número de trampas instaladas</span>
						<div class="ba text-left pl-1" style="width: 20%">{{ order.data[36] }}</div>
					</div>
					<div class="mb-1 d-flex justify-space-between">
						<span>Trampas de tubo</span>
						<div class="ba text-left pl-1" style="width: 20%">{{ order.data[37] }}</div>
					</div>
					<div class="mb-1 d-flex justify-space-between">
						<span>Trampas cajas pegajosas</span>
						<div class="ba text-left pl-1" style="width: 20%">{{ order.data[38] }}</div>
					</div>
					<div class="mb-1 d-flex justify-space-between">
						<span>N° de Capturas Vivas</span>
						<div class="ba text-left pl-1" style="width: 20%">
							{{ order.data[121] }}
						</div>
					</div>
				</div>
				<div style="flex: 1">
					<div class="text-left mb-2">
						<span style="font-size:16px; font-weight:bold;">Productos Utilizados</span>
					</div>
					<div class="text-left d-flex flex-wrap">
						<input type="checkbox" style="width: 10%;" v-model="order.data[39][0]" />
						<div style="width: 90%; padding-left:10px;">
							RASTOP PLUS BLOQUE / BROMADIOLONA 0,005% +BENZOATO DE DENATORIO
							<br />
							ISP: 870/24
							<br />Dosis: 2 SACHET DE 10 GRS CADA UNO
						</div>
						<input type="checkbox" style="width: 10%;" v-model="order.data[39][1]" />
						<span style="width: 90%; padding-left:10px;">
							RASTOP PELLET EN SOBRE / BROMADIOLONA 0,005% +BENZOATO DE DENATORIO ISP:
							<br />
							P-729/25
							<br />Dosis: 2 SACHET DE 10 GRS CADA UNO
						</span>
					</div>
				</div>
			</div>
			<div class="d-flex">
				<div style="width: 25%;" class="mr-2">
					<div class="d-flex">
						<div style="width: 36%" class="bl bt bb">
							<span style="font-size: 7px; font-weight:bold;">TIPO DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bl bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE OBSERVACIÓN</span>
						</div>
					</div>
					<div class="bb" v-for="(x, index) in 20" :key="index">
						<div class="d-flex">
							<div style="height:13px; width: 36%" class="bl ">
								<span v-if="order.data[40][index]">
									{{ order.data[40][index].tipo }}
								</span>
							</div>
							<div style="height:13px; width: 32%" class="bl  br">
								<span v-if="order.data[40][index]">
									{{ order.data[40][index].numero }}
								</span>
							</div>
							<div style="height:13px; width: 32%" class=" br">
								<span v-if="order.data[40][index]">
									{{ order.data[40][index].observacion }}
								</span>
							</div>
						</div>
					</div>
				</div>
				<div style="width: 25%;" class="mr-2">
					<div class="d-flex">
						<div style="width: 36%" class="bl bt bb">
							<span style="font-size: 7px; font-weight:bold;">TIPO DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bl bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE OBSERVACIÓN</span>
						</div>
					</div>
					<template v-for="(x, index) in 40">
						<template v-if="x > 20">
							<div class="d-flex bb" :key="index">
								<div style="height:13px; width: 36%" class="bl ">
									<span v-if="order.data[40][index]">
										{{ order.data[40][index].tipo }}
									</span>
								</div>
								<div style="height:13px; width: 32%" class="bl  br">
									<span v-if="order.data[40][index]">
										{{ order.data[40][index].numero }}
									</span>
								</div>
								<div style="height:13px; width: 32%" class=" br">
									<span v-if="order.data[40][index]">
										{{ order.data[40][index].observacion }}
									</span>
								</div>
							</div>
						</template>
					</template>
				</div>
				<div style="width: 25%;" class="mr-2">
					<div class="d-flex">
						<div style="width: 36%" class="bl bt bb">
							<span style="font-size: 7px; font-weight:bold;">TIPO DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bl bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE OBSERVACIÓN</span>
						</div>
					</div>
					<template v-for="(x, index) in 60">
						<template v-if="x > 40">
							<div class="d-flex bb" :key="index">
								<div style="height:13px; width: 36%" class="bl ">
									<span v-if="order.data[40][index]">{{
										order.data[40][index].tipo
									}}</span>
								</div>
								<div style="height:13px; width: 32%" class="bl  br">
									<span v-if="order.data[40][index]">{{
										order.data[40][index].numero
									}}</span>
								</div>
								<div style="height:13px; width: 32%" class=" br">
									<span v-if="order.data[40][index]">{{
										order.data[40][index].observacion
									}}</span>
								</div>
							</div>
						</template>
					</template>
				</div>
				<div style="width: 25%;" class="mr-2">
					<div class="d-flex">
						<div style="width: 36%" class="bl bt bb">
							<span style="font-size: 7px; font-weight:bold;">TIPO DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bl bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE OBSERVACIÓN</span>
						</div>
					</div>
					<template v-for="(x, index) in 80">
						<template v-if="x > 60">
							<div class="d-flex bb" :key="index">
								<div style="height:13px; width: 36%" class="bl ">
									<span v-if="order.data[40][index]">
										{{ order.data[40][index].tipo }}
									</span>
								</div>
								<div style="height:13px; width: 32%" class="bl  br">
									<span v-if="order.data[40][index]">
										{{ order.data[40][index].numero }}
									</span>
								</div>
								<div style="height:13px; width: 32%" class=" br">
									<span v-if="order.data[40][index]">
										{{ order.data[40][index].observacion }}
									</span>
								</div>
							</div>
						</template>
					</template>
				</div>
			</div>
			<v-row>
				<v-col cols="12" md="4" order="4">
					<div style="font-size:16px; font-weight:bold;" class="text-left">
						Número de observaciones:
					</div>
					<v-row no-gutters justify="space-between">
						<v-col cols="9" class="text-left">1-Captura</v-col>
						<v-col cols="3" class="text-left bl br ba">
							<input type="text" style="width: 100%" v-model="order.data[41]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between">
						<v-col cols="9" class="text-left">2-Trampas bloqueadas</v-col>
						<v-col cols="3" class="text-left bl br bb">
							<input type="text" style="width: 100%" v-model="order.data[42]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between">
						<v-col cols="9" class="text-left">3-Trampa destruida</v-col>
						<v-col cols="3" class="text-left bl br bb">
							<input type="text" style="width: 100%" v-model="order.data[43]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between">
						<v-col cols="9" class="text-left">4-Babosas</v-col>
						<v-col cols="3" class="text-left bl br bb">
							<input type="text" style="width: 100%" v-model="order.data[44]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between">
						<v-col cols="9" class="text-left">5-Hongos</v-col>
						<v-col cols="3" class="text-left bl br bb">
							<input type="text" style="width: 100%" v-model="order.data[45]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between">
						<v-col cols="9" class="text-left">6-Polvo</v-col>
						<v-col cols="3" class="text-left bl br bb">
							<input type="text" style="width: 100%" v-model="order.data[46]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between">
						<v-col cols="9" class="text-left">7-Sustraida</v-col>
						<v-col cols="3" class="text-left bl br bb">
							<input type="text" style="width: 100%" v-model="order.data[47]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between">
						<v-col cols="9" class="text-left">8-Muestras roedores</v-col>
						<v-col cols="3" class="text-left bl br bb">
							<input type="text" style="width: 100%" v-model="order.data[48]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between">
						<v-col cols="9" class="text-left">9-Trampas tratadas</v-col>
						<v-col cols="3" class="text-left bl br bb">
							<input type="text" style="width: 100%" v-model="order.data[49]" />
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<div class="my-2 text-left">
				<div class="text-uppercase caption">Observaciones: {{ order.data[50] }}</div>
			</div>
			<div class="d-flex justify-space-between">
				<div>
					<div class="bb text-left">
						<span style="width: 30%" class="text-uppercase body-1">
							Cliente:
						</span>
						<span class="body-2 text-capitalize" v-if="order.cliente">
							{{ order.cliente.nombre }} RUT: {{ order.cliente.rut }}
						</span>
					</div>
					<v-img height="200" eager contain :src="order.firma" alt="firma" />
					<span style="font-size: 19px">www.lusazu.cl</span>
				</div>
				<div>
					<div class="bb text-left">
						<span style="width: 30%" class="text-uppercase body-1">
							Tecnico:
						</span>
						<span class="body-2 text-capitalize" v-if="order.datosTecnico">
							{{ order.datosTecnico.nombre }} RUT: {{ order.datosTecnico.rut }}
						</span>
					</div>
					<v-img height="200" eager contain :src="order.firmaTecnico" alt="firma" />
					<span style="font-size: 19px">info@lusazu.cl</span>
				</div>
			</div>
			<!-- End Form -->
			<!-- <div class="page-break"></div> -->
			<!-- <v-col v-if="images.length" cols="12">Antecedentes fotográficos:</v-col>
			<div style="width: 100%">
				<div class="d-flex flex-wrap" v-if="images.length">
					<div v-for="(img, key) in images" :key="key">
						<a target="_blank" :href="img.url">
							<v-img
								lazy-src="@/assets/placeholder.png"
								:src="img.url"
								class="mr-1 foto-antecedentes"
								alt="imagen de la orden"
							>
								<div class="bg caption text-right">{{ createAt(img._id) }}</div>
							</v-img>
						</a>
					</div>
				</div>
			</div> -->
		</v-container>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
import moment from 'moment';
export default {
	data() {
		return {
			order: null,
			images: undefined,
		};
	},
	created() {
		document.getElementById('viewport').setAttribute('content', 'max-width=950px');
	},
	async mounted() {
		const { workOrder, documents } = await this.getWorkOrder({
			idLodging: this.$route.params.idLodging,
			indexWorkOrder: this.$route.params.index,
		});
		this.order = workOrder;
		// Hay OT corruptas guardadas sin el array data.
		if (!Array.isArray(this.order.data)) this.order.data = [];
		// Hay OT con data vacio o sin estos campos; el template los indexa como arrays.
		[39, 40].forEach(index => {
			if (!Array.isArray(this.order.data[index])) this.order.data[index] = [];
		});
		if (this.order.data[103]) this.order.data[103] = this.order.data[103].split('\n');
		if (this.order.reco2) this.order.reco2 = this.order.reco2.split('\n');
		if (this.order.reco3) this.order.reco3 = this.order.reco3.split('\n');
		this.images = documents.filter(document => {
			const typeDocument = document.url.slice(-3);
			if (this.validateImage(typeDocument)) return true;
			return false;
		});
	},
	methods: {
		getObservaciones(observationType) {
			if (observationType) {
				if (this.order.data[21].customObservaciones.length)
					return this.order.data[21].customObservaciones;
			}
		},
		getRecomendaciones(observationType) {
			if (observationType) {
				if (this.order.data[21].customRecomendaciones.length)
					return this.order.data[21].customRecomendaciones;
			}
		},
		isToday(orderDate, datePhoto) {
			return moment(orderDate).isSame(datePhoto, 'day');
		},
		createAt(id) {
			if (id) return moment(this.dateFromObjectId(id)).format('lll');
			else return 'Sin fecha';
		},
		hasInfo(item) {
			return item !== 'Sin info';
		},
		dateFromObjectId(objectId) {
			return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
		},
		validateImage(typeDocument) {
			typeDocument = typeDocument.toLowerCase();
			if (typeDocument === 'jpg' || typeDocument === 'png' || typeDocument === 'peg')
				return true;
			return false;
		},
		formatWorkOrder(workOrder) {
			return workOrder.map(item => {
				if (item === null || item === false) return 'No';
				if (item === true) return 'Si';
				else return item;
			});
		},
		...mapActions({
			getWorkOrder: 'Lodging/getWorkOrder',
			getLodging: 'Lodging/getLodging',
		}),
	},
};
</script>

<style scoped>
input {
	height: 18px;
	border: none !important;
}
.nw {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.marca-agua {
	position: absolute;
	top: 40%;
	left: 30%;
	opacity: 0.1;
	z-index: 1;
}
/* I created this class in order to make smaller a particular  text */
.class-custom {
	font-size: 8px !important;
}
* {
	color: black;
	-webkit-print-color-adjust: exact !important;
	color-adjust: exact !important;
	font-size: 12px;
}
/* Tamaño pagina 1056 1392 px  */
@media print {
	@page {
		size: A3 portrait;
		width: 100%;
		margin: auto;
	}
	.firmas {
		max-height: 90px !important;
		height: 90px !important;
	}
	.antecedentes-fotograficos {
		display: none;
	}
	.border-ot {
		display: table;
		margin: 0 auto;
		border: 0px !important;
	}
	.page-break {
		display: block;
		page-break-before: always;
	}
}
.border-a {
	border-bottom: 2px solid gray !important ;
	margin-bottom: 2px;
	width: 98%;
	max-width: 1050px;
	height: 1300px;
}
.ba {
	border: 1px solid black;
}
.bl {
	border-left: 1px solid black;
}
.br {
	border-right: 1px solid black;
}
.bt {
	border-top: 1px solid black;
}
.bb {
	border-bottom: 1px solid black;
}
.bg {
	background-color: #0056c7;
}
.bg-secondary {
	background-color: #80bd00;
}
.cc {
	width: 30px;
	height: 15px;
}
.border-ot {
	background-color: white;
	margin: 5px auto;
	width: 100%;
	max-width: 1040px;
}
.foto-antecedentes {
	border-radius: 15px;
	margin-bottom: 50px;
	height: 200px;
	width: 200px;
	border: 1px solid black;
}

.text--color {
	color: rgba(0, 0, 0, 0.74);
}
input {
	pointer-events: none;
}
</style>
